export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_PICKER_FORMAT = 'DD-MM-YYYY';
export const ISO8601_DATE_FORMAT = 'YYYY-MM-DD';

export const MILLISECONDS_DAY = 1000 * 60 * 60 * 24;

export const TIME_FORMAT = 'hh:mm:ss';
export const TIME_PICKER_FORMAT = 'HH:mm';
